import Vue from 'vue'
const app = {
  state: {
    visitedViews: []
  },
  mutations: {
    ADD_VISITED_VIEWS: (state, view) => {
      if (state.visitedViews.some(v => v.path === view.path)) return
      // 风控工单 id问题
      if (view.params.Id && state.visitedViews.some(v => v.path.indexOf(view.path.replace(view.params.Id, '')) >= 0)) return
      state.visitedViews.push({
        name: view.name,
        path: view.path,
        title: view.meta.title || 'no-name'
      })
    },
    DEL_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
    },
    UPDATE_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          Vue.set(state.visitedViews, i, {
            name: view.name,
            path: view.path,
            title: view.meta.title
          })
          break
        }
      }
    }
  },
  actions: {
    addVisitedViews ({ commit }, view) {
      commit('ADD_VISITED_VIEWS', view)
    },
    delVisitedViews ({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    updateVisitedViews ({ commit }, view) {
      return new Promise((resolve) => {
        commit('UPDATE_VISITED_VIEWS', view)
      })
    }
  }
}

export default app
